import React, { forwardRef } from 'react';
import Container from './Container.js';
const ActionCardHeading = ({
  heading
}) => /*#__PURE__*/React.createElement("h2", {
  className: "ebds-action-card__heading"
}, heading);
const ActionCardDescription = ({
  description
}) => /*#__PURE__*/React.createElement("div", {
  className: "ebds-action-card__description"
}, description);
const ActionCardActions = ({
  primaryButton,
  secondaryButton,
  tertiaryButton
}) => /*#__PURE__*/React.createElement("div", {
  className: "ebds-action-card__actions__items"
}, primaryButton, secondaryButton, tertiaryButton);
const ActionCard = /*#__PURE__*/forwardRef(({
  heading = null,
  description = null,
  primaryButton = null,
  secondaryButton = null,
  tertiaryButton = null,
  withBorderBottom = false
}, ref) => {
  const isWithContent = heading || description;
  const isWithActions = primaryButton || secondaryButton;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("section", {
    ref: ref,
    className: `ebds-action-card ${withBorderBottom && 'ebds-action-card--border-bottom'}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "ebds-action-card__flyout"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ebds-action-card__body"
  }, isWithContent && /*#__PURE__*/React.createElement("div", {
    className: "ebds-action-card__body__content"
  }, heading && /*#__PURE__*/React.createElement(ActionCardHeading, {
    heading: heading
  }), description && /*#__PURE__*/React.createElement(ActionCardDescription, {
    description: description
  })), isWithActions && /*#__PURE__*/React.createElement("div", {
    className: "ebds-action-card__body__actions"
  }, /*#__PURE__*/React.createElement(ActionCardActions, {
    primaryButton: primaryButton,
    secondaryButton: secondaryButton,
    tertiaryButton: tertiaryButton
  }))))));
});
export default ActionCard;